// Yayıncı Kullanım Sözleşmesi — Vokelle'nin yayıncı öz-servis katmanına
// (Faz 5) kayıt olan yayıncılara panel erişimi verilmeden önce sunulur ve
// "Okudum, Anladım, Kabul Ediyorum" ile onaylanması zorunludur.
// Bu metinde YALNIZCA "Vokelle" ismi geçer (VokerStudio, PayTR vb. geçmez).

export const PUBLISHER_AGREEMENT = {
  title: 'Yayıncı Kullanım Sözleşmesi',
  intro:
    'Bu Sözleşme, "Yayıncı" sıfatıyla Vokelle\'ye kayıt olan gerçek veya tüzel kişi ile Vokelle arasında, aşağıda belirtilen şartlar dahilinde akdedilmiştir. Yayıncı, işbu Sözleşme\'yi okuyup anladığını ve tüm hükümlerini kayıtsız şartsız kabul ettiğini, "Okudum, Anladım, Kabul Ediyorum" butonuna tıklayarak beyan ve taahhüt eder.',
  sections: [
    {
      h: 'Madde 1 — Taraflar ve Tanımlar',
      p: [
        '1.1. "Vokelle": işbu hizmeti sunan platformu ifade eder.',
        '1.2. "Yayıncı": Vokelle\'nin sunduğu öz-servis takip linki hizmetinden faydalanmak üzere kayıt olan gerçek veya tüzel kişiyi ifade eder.',
        '1.3. "Hizmet": Yayıncının, tanıtımını yaptığı üçüncü taraf internet sitelerine yönlendirme yapan, tıklama istatistiği üreten takip linki oluşturma aracını ifade eder.',
        '1.4. "Performans Verisi": Yayıncının ürettiği takip linklerine ilişkin tıklama sayısı, tarih/saat bilgisi, kampanya etiketleri, yönlendirme istatistikleri ile Yayıncının Vokelle\'ye bildirdiği ad, unvan, platform ve profil fotoğrafı gibi bilgilerin tamamını ifade eder.',
      ],
    },
    {
      h: 'Madde 2 — Hizmetin Niteliği',
      p: [
        '2.1. Hizmet, Vokelle tarafından herhangi bir bedel talep edilmeksizin, tamamen Vokelle\'nin insiyatifinde ve ön bildirimsiz olarak değiştirilebilir, kısıtlanabilir, askıya alınabilir veya sonlandırılabilir şekilde sunulmaktadır.',
        '2.2. Yayıncı, Hizmet\'in kesintisiz, hatasız veya belirli bir doğruluk düzeyinde çalışacağına ilişkin Vokelle tarafından herhangi bir garanti verilmediğini kabul eder. Tıklama sayıları ve türetilen tüm istatistikler yaklaşık/tahmini nitelikte olup kesin ve nihai veri teşkil etmez.',
      ],
    },
    {
      h: 'Madde 3 — Yayıncının Beyan ve Taahhütleri',
      p: [
        '3.1. Yayıncı, kayıt sırasında verdiği tüm bilgilerin (ad, platform, iletişim bilgileri dahil) doğru, güncel ve eksiksiz olduğunu beyan eder.',
        '3.2. Yayıncı, üretilen takip linklerini yalnızca kendi meşru içerik/tanıtım faaliyetleri kapsamında kullanacağını; botlar, otomasyon araçları, tıklama çiftlikleri veya benzeri yollarla suni/yanıltıcı tıklama üretmeyeceğini kayıtsız şartsız taahhüt eder.',
        '3.3. Yayıncı, Hizmet\'i yasa dışı, yanıltıcı, üçüncü kişilerin haklarını ihlal eden veya kamu düzenine aykırı hiçbir amaçla kullanmayacağını kabul eder.',
        '3.4. İşbu maddede sayılan yükümlülüklerin ihlali halinde doğacak her türlü hukuki ve cezai sorumluluk münhasıran Yayıncıya aittir; Vokelle bu kapsamda herhangi bir sorumluluk kabul etmez.',
      ],
    },
    {
      h: 'Madde 4 — Performans Verisinin Vokelle Tarafından Kullanımı',
      p: [
        '4.1. Yayıncı, Hizmet kapsamında ürettiği tüm Performans Verisinin — sınırlama olmaksızın toplanması, işlenmesi, saklanması, analiz edilmesi, Vokelle\'nin diğer kullanıcılarıyla karşılaştırmalı biçimde paylaşılması, Vokelle\'nin ürün, tanıtım, pazarlama ve iş geliştirme faaliyetlerinde referans olarak kullanılması ve Vokelle\'nin uygun göreceği şekil ve mecralarda görüntülenmesi dahil olmak üzere — Vokelle tarafından serbestçe kullanılabileceğini gayrikabili rücu surette kabul, beyan ve taahhüt eder.',
        '4.2. Yayıncı, Performans Verisi üzerinde Vokelle lehine, süresiz, bedelsiz ve münhasır olmayan bir kullanım hakkı tanıdığını kabul eder. Bu kullanım hakkı, işbu Sözleşme\'nin herhangi bir sebeple sona ermesi halinde dahi, Sözleşme\'nin yürürlükte olduğu döneme ait Performans Verisi bakımından geçerliliğini korur.',
        '4.3. Yayıncının Hizmet üzerinden elde ettiği başarı, tıklama performansı ve bu performansa ilişkin her türlü veri, Vokelle\'nin sunduğu hizmetin bir çıktısı olarak değerlendirilir ve Vokelle\'nin meşru menfaati kapsamında kullanıma sunulmuş sayılır.',
      ],
    },
    {
      h: 'Madde 5 — Sorumluluk Sınırlaması',
      p: [
        '5.1. Vokelle; Yayıncı ile Yayıncının tanıtımını yaptığı üçüncü taraflar (sunucu sahipleri, izleyiciler, iş ortakları dahil) arasında doğabilecek hiçbir anlaşmazlıkta taraf değildir ve bu anlaşmazlıklardan doğan hiçbir zarardan sorumlu tutulamaz.',
        '5.2. Vokelle\'nin işbu Sözleşme\'den doğabilecek toplam sorumluluğu, her halükârda ve hiçbir şekilde, Hizmet\'in Yayıncı tarafından ücretsiz kullanılmış olması sebebiyle sıfırdır.',
        '5.3. Yayıncı, Hizmet\'i kullanımından doğabilecek her türlü doğrudan veya dolaylı zarara ilişkin olarak Vokelle\'yi ve Vokelle\'nin yetkilileri ile çalışanlarını her türlü talep, dava ve sorumluluktan beri kıldığını kabul eder.',
      ],
    },
    {
      h: 'Madde 6 — Fesih',
      p: [
        '6.1. Vokelle, herhangi bir gerekçe göstermeksizin ve önceden bildirimde bulunmaksızın Yayıncının hesabını askıya alma veya kalıcı olarak sonlandırma hakkını saklı tutar.',
        '6.2. Yayıncı, dilediği zaman hesabını kapatarak Hizmet\'i kullanmaktan vazgeçebilir; ancak bu durum, Madde 4 uyarınca Vokelle\'ye tanınan kullanım hakkını geçmişe etkili olarak ortadan kaldırmaz.',
      ],
    },
    {
      h: 'Madde 7 — Değişiklik Yetkisi',
      p: [
        '7.1. Vokelle, işbu Sözleşme hükümlerini tek taraflı olarak değiştirme hakkını saklı tutar. Güncel sözleşme metni her zaman platform üzerinden erişilebilir olacaktır.',
      ],
    },
    {
      h: 'Madde 8 — Uyuşmazlıkların Çözümü',
      p: [
        '8.1. İşbu Sözleşme\'nin uygulanmasından doğan uyuşmazlıklarda Türk hukuku uygulanır; İstanbul (Anadolu) Mahkemeleri ve İcra Daireleri münhasıran yetkilidir.',
      ],
    },
    {
      h: 'Madde 9 — Yürürlük',
      p: [
        '9.1. İşbu Sözleşme, Yayıncının "Okudum, Anladım, Kabul Ediyorum" butonuna tıklaması ile birlikte elektronik ortamda akdedilmiş sayılır ve derhal yürürlüğe girer.',
      ],
    },
  ],
};
